import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { CheckCircle } from "react-feather";
import "./ServicesCardPayers.css"; // Updated styles
import service1 from "../Assets/ServicePayerImages/1. Claim Processing.png";
import service2 from "../Assets/ServicePayerImages/2. Enrolment & Eligibility.jpeg";
import service3 from "../Assets/ServicePayerImages/3. EDI Clearinghouse & File Management.jpeg";
import service4 from "../Assets/ServicePayerImages/4. Utilization Management (UM) & Prior Authorization Support.jpg";
import service5 from "../Assets/ServicePayerImages/5. Appeals & Grievances Processing.jpg";
import service6 from "../Assets/ServicePayerImages/6. Call Center Operations.jpg";
import service7 from "../Assets/ServicePayerImages/7. Credentialing & Provider Data Management.jpg";
import service8 from "../Assets/ServicePayerImages/8. Premium Billing & Finance Support.jpg";
import service9 from "../Assets/ServicePayerImages/9. Reporting & Analytics.jpg";
import service10 from "../Assets/ServicePayerImages/10. Mailroom & Fulfilment Services.jpg";
import service11 from "../Assets/ServicePayerImages/11. Technical Help Desk & Application Support.jpg";
import service12 from "../Assets/ServicePayerImages/12. Encounter Data Management.jpg";

const ServicesCardPayers = () => {
  const servicesData = [
    {
      image: service1,
      title: "Claims Processing & Adjudication",
      points: [
        "Data entry for paper claims (CMS-1500, UB-04)",
        "Claims validation, coding edits, and auto-adjudication support",
        "Out-of-network claim handling",
        "Coordination of Benefits (COB) and duplicate checking",
        "Claims audit and payment integrity reviews",
      ],
    },
    {
      image: service2,
      title: "Enrolment & Eligibility",
      points: [
        "Processing EDI 834 files and manual enrolment forms",
        "Member eligibility reconciliation with CMS/State/Marketplace",
        "Retroactive updates and disenrollment",
        "ID card generation and welcome kit fulfilment",
      ],
    },
    {
      image: service3,

      title: "EDI Clearinghouse & File Management",
      points: [
        "Inbound and outbound EDI transactions (834, 837, 835, 820, 276/277)",
        "Real-time eligibility (270/271) and claim status handling",
        "Translation, validation, TA1/999/277CA report management",
        "Partner onboarding and trading partner management",
      ],
    },
    {
      image: service4,

      title: "Utilization Management (UM) & Prior Authorization Support",
      points: [
        "Intake and routing of prior auth requests (phone, fax, portal)",
        "Medical necessity screening by RNs",
        "Non-clinical case setup and documentation indexing",
        "UM queue management during overflow or peak season",
      ],
    },

    {
      image: service5,

      title: "Appeals & Grievances Processing",
      points: [
        "Intake and triage of member/provider appeals and grievances",
        "Documentation collection and logging into A&G systems",
        "SLA monitoring and case closure documentation",
        "Support for regulatory reporting (CMS, Medicaid)",
      ],
    },
    {
      image: service6,

      title: "Call Center Operations",
      points: [
        "Member Call Center: benefit clarification, ID cards, claims status",
        "Provider Call Center: claims, eligibility, referrals, credentialing",
        "After-hours or overflow support for inbound calls",
        "Multilingual support and ADA-accessible services",
      ],
    },
    {
      image: service7,

      title: "Credentialing & Provider Data Management",
      points: [
        "Primary source verification and CAQH updates",
        "Document collection and verification",
        "Recredentialing and expiration tracking",
        "Directory accuracy and demographic change processing",
      ],
    },
    {
      image: service8,

      title: "Premium Billing & Finance Support",
      points: [
        "Group/individual invoice generation",
        "Payment posting and aging analysis",
        "Refund and recoupment processing",
        " Capitation and remittance advice preparation",
      ],
    },
    {
      image: service9,

      title: "Reporting & Analytics (Non-core)",
      points: [
        "Monthly KPI report creation and SLA dashboards",
        "Regulatory file preparation (HEDIS, 1095-A, CMS MMR, RADV)",
        "Trend analysis and data visualization",
        " Manual reconciliation tasks (e.g., encounter acceptance rates)",
      ],
    },
    {
      image: service10,

      title: "Mailroom & Fulfilment Services",
      points: [
        "Paper claim scanning and indexing",
        "Appeals/UM document scanning and routing",
        "Outbound printing of EOBs, ANOC, EOC, denial letters",
        " Secure document archival",
      ],
    },
    {
      image: service11,

      title: "Technical Help Desk & Application Support",
      points: [
        "Login/access issues for internal or external portals",
        "First-line technical troubleshooting",
        "Password resets and provisioning for CRM/EDI portals",
        " System ticketing and SLA-based resolution tracking",
      ],
    },
    {
      image: service12,

      title: "Encounter Data Management",
      points: [
        "Professional and institutional encounter file creation",
        "EDPS and RAPS submission management (Medicare)",
        "Medicaid encounter validation and reconciliation",
        " Error correction and resubmission workflows",
      ],
    },
  ];
  return (
    <Container fluid className="services-container">
      <Row className="text-center services-header">
        <p className="services-subtitle mt-5">Services Spectrum</p>
      </Row>

      {servicesData.map((service, index) => (
        <div className="container mt-5" key={index}>
          <Row
            className={`services-content ${
              index % 2 === 0 ? "reverse" : ""
            } mb-5`}
          >
            <Col
              lg={6}
              className="services-image-container"
              style={{ marginTop: "20px" }}
            >
              <img
                src={service.image}
                alt={service.title}
                className="services-image"
              />
            </Col>
            <Col lg={6} className="services-text">
              <h3 className="services-heading">{service.title}</h3>
              <p className="services-description">{service.description}</p>
              <div className="services-list">
                {service.points.map((point, i) => (
                  <p key={i}>
                    <i className="fa fa-check-circle services-icon" />
                    {point}
                  </p>
                ))}
              </div>
            </Col>
          </Row>
        </div>
      ))}
    </Container>
  );
};

export default ServicesCardPayers;
